// extracted by mini-css-extract-plugin
module.exports = {"alert":"page_alert__1AK_J","termsBlock":"page_termsBlock__2SCWA","termsSpan":"page_termsSpan__2qQM-"};